import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Mariana Web Integrations bootstraps on window `load` only. Client-side route
 * changes mount `[data-mariana-integrations]` later — call their public API
 * again after each navigation when an embed is present on the page.
 */
export default function MarianaTekAfterNavigate() {
    const { pathname } = useLocation();

    useEffect(() => {
        let cancelled = false;

        const run = () => {
            if (cancelled) return;

            const container = document.querySelector("[data-mariana-integrations]");
            if (!container) return;
            // Skip if Mariana already mounted an iframe/zoid wrapper into the
            // placeholder (e.g. their window-load handler beat us to it on first paint).
            if (container.firstElementChild) return;

            const render = window.MTIntegrations?.render;
            if (typeof render !== "function") return;

            try {
                render();
            } catch {
                /* No matching node or embed already attached */
            }
        };

        // Wait until after paint so React has committed the integration container.
        const frame = requestAnimationFrame(() => {
            requestAnimationFrame(run);
        });

        return () => {
            cancelled = true;
            cancelAnimationFrame(frame);
        };
    }, [pathname]);

    return null;
}
